module.exports = __webpack_public_path__ + "files/bfc27c5ec5d4ad156120f3e0c036c28a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-1.png
// module id = 509
// module chunks = 76